<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVaultStore, WrongPasswordError } from '../stores/vault'

const { t } = useI18n()
const vault = useVaultStore()

const pw = ref('')
const pw2 = ref('')
const warned = ref(false)
const err = ref('')
const busy = ref(false)

const MIN = 4

async function submit() {
  err.value = ''
  if (busy.value) return
  if (vault.initialized) {
    busy.value = true
    try {
      await vault.unlock(pw.value)
    } catch (e) {
      err.value = e instanceof WrongPasswordError ? t('lock.errWrong') : String(e)
      pw.value = ''
    } finally { busy.value = false }
    return
  }
  // 첫 실행: 금고 생성
  if (pw.value.length < MIN) { err.value = t('lock.errShort', { n: MIN }); return }
  if (pw.value !== pw2.value) { err.value = t('lock.errMismatch'); return }
  if (!warned.value) { err.value = t('lock.errWarn'); return }
  busy.value = true
  try { await vault.setup(pw.value) } catch (e) { err.value = String(e) } finally { busy.value = false }
}

async function forgot() {
  if (!confirm(t('lock.forgotConfirm'))) return
  await vault.wipeAll()
  pw.value = pw2.value = ''; warned.value = false; err.value = ''
}
</script>

<template>
  <div class="lock">
    <form class="lock-card" @submit.prevent="submit">
      <div class="lock-ico" aria-hidden="true">●</div>
      <h1>{{ vault.initialized ? t('lock.unlockTitle') : t('lock.setupTitle') }}</h1>
      <p v-if="!vault.initialized" class="lock-desc">{{ t('lock.setupDesc') }}</p>

      <input
        v-model="pw" type="password" :placeholder="t('lock.password')"
        autocomplete="off" autofocus inputmode="text"
      />
      <input
        v-if="!vault.initialized" v-model="pw2" type="password"
        :placeholder="t('lock.confirm')" autocomplete="off"
      />

      <label v-if="!vault.initialized" class="lock-warn">
        <input type="checkbox" v-model="warned" />
        <span>{{ t('lock.warnLabel') }}</span>
      </label>

      <p v-if="err" class="lock-err">{{ err }}</p>

      <button type="submit" :disabled="busy">
        {{ busy ? (vault.initialized ? t('lock.unlocking') : t('lock.creating'))
                : (vault.initialized ? t('lock.unlock') : t('lock.create')) }}
      </button>

      <button v-if="vault.initialized" type="button" class="lock-forgot" @click="forgot">{{ t('lock.forgot') }}</button>
    </form>
  </div>
</template>
